var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service, Inject } from "@bluelibs/core";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { ClientRequestPossibleStatus } from "@root/api.types";
import { UsersCollection, ClientRequestsCollection, } from "@bundles/UIAppBundle/collections";
let ClientRequestEditForm = class ClientRequestEditForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "reference",
                label: t("management.client_requests.fields.reference"),
                name: ["reference"],
                tooltip: t("management.client_requests.fields.reference_description"),
                component: Ant.Input,
            },
            {
                id: "sourceLead",
                label: t("management.client_requests.fields.sourceLead"),
                name: ["sourceLead"],
                tooltip: t("management.client_requests.fields.sourceLead_description"),
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsxs(Ant.Select, { allowClear: true, placeholder: t("management.client_requests.fields.sourceLead"), children: [_jsx(Ant.Select.Option, { value: "WEBSITE", children: "Website" }, "WEBSITE"), _jsx(Ant.Select.Option, { value: "EMAIL", children: "Email" }, "EMAIL"), _jsx(Ant.Select.Option, { value: "PHONE", children: "Phone" }, "PHONE"), _jsx(Ant.Select.Option, { value: "PROSPECTION", children: "Prospection" }, "PROSPECTION"), _jsx(Ant.Select.Option, { value: "AGENCY", children: "Agency" }, "AGENCY"), _jsx(Ant.Select.Option, { value: "SC_LOCAL", children: "Sc Local" }, "SC_LOCAL"), _jsx(Ant.Select.Option, { value: "FURET", children: "Furet" }, "FURET"), _jsx(Ant.Select.Option, { value: "TRAVAUX_COM", children: "Travaux Com" }, "TRAVAUX_COM"), _jsx(Ant.Select.Option, { value: "PARTNER_APP", children: "Partner App" }, "PARTNER_APP"), _jsx(Ant.Select.Option, { value: "OTHER", children: "Other" }, "OTHER")] }) })),
            },
            {
                id: "sourceLeadPhone",
                label: t("management.client_requests.fields.sourceLeadPhone"),
                name: ["sourceLeadPhone"],
                component: Ant.Input,
            },
            {
                id: "nextFollowUp",
                label: t("management.client_requests.fields.nextFollowUp"),
                name: ["nextFollowUp"],
                initialValue: null,
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsxs(Ant.Select, { allowClear: true, placeholder: t("management.client_requests.fields.nextFollowUp"), children: [_jsx(Ant.Select.Option, { value: "QUOTES_1", children: "Quotes 1" }, "QUOTES_1"), _jsx(Ant.Select.Option, { value: "QUOTES_2", children: "Quotes 2" }, "QUOTES_2"), _jsx(Ant.Select.Option, { value: "QUOTES_3", children: "Quotes 3" }, "QUOTES_3"), _jsx(Ant.Select.Option, { value: "QUOTES_4", children: "Quotes 4" }, "QUOTES_4"), _jsx(Ant.Select.Option, { value: "INVOICE_1", children: "Invoice 1" }, "INVOICE_1"), _jsx(Ant.Select.Option, { value: "INVOICE_2", children: "Invoice 2" }, "INVOICE_2"), _jsx(Ant.Select.Option, { value: "INVOICE_3", children: "Invoice 3" }, "INVOICE_3")] }) })),
            },
            {
                id: "nextFollowUpDate",
                label: t("management.client_requests.fields.nextFollowUpDate"),
                name: ["nextFollowUpDate"],
                initialValue: null,
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsx(UIComponents.DatePicker, { required: false }) })),
            },
            {
                id: "activity",
                label: t("management.client_requests.fields.activity"),
                name: ["activity"],
                tooltip: t("management.client_requests.fields.activity_description"),
                initialValue: "PLUMBING",
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsxs(Ant.Select, { allowClear: true, placeholder: t("management.client_requests.fields.activity"), children: [_jsx(Ant.Select.Option, { value: "MECHANICAL_VENTILATION", children: "Mechanical Ventilation" }, "MECHANICAL_VENTILATION"), _jsx(Ant.Select.Option, { value: "PLUMBING", children: "Plumbing" }, "PLUMBING"), _jsx(Ant.Select.Option, { value: "RENOVATION", children: "Renovation" }, "RENOVATION"), _jsx(Ant.Select.Option, { value: "HEATING", children: "Heating" }, "HEATING"), _jsx(Ant.Select.Option, { value: "AIR_CONDITIONING", children: "Air Conditioning" }, "AIR_CONDITIONING"), _jsx(Ant.Select.Option, { value: "MULTISERVICE", children: "Multiservice" }, "MULTISERVICE"), _jsx(Ant.Select.Option, { value: "LOCKSMITHING", children: "Locksmithing" }, "LOCKSMITHING"), _jsx(Ant.Select.Option, { value: "ELECTRICAL", children: "Electrical" }, "ELECTRICAL")] }) })),
            },
            {
                id: "description",
                label: t("management.client_requests.fields.description"),
                name: ["description"],
                tooltip: t("management.client_requests.fields.description_description"),
                component: Ant.Input,
            },
            {
                id: "emergencyLevel",
                label: t("management.client_requests.fields.emergencyLevel"),
                name: ["emergencyLevel"],
                tooltip: t("management.client_requests.fields.emergencyLevel_description"),
                initialValue: 50,
                component: Ant.InputNumber,
            },
            {
                id: "status",
                label: t("management.client_requests.fields.status"),
                name: ["status"],
                initialValue: ClientRequestPossibleStatus.S_00100_CLIENT_REQUEST,
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsxs(Ant.Select, { allowClear: true, placeholder: t("management.client_requests.fields.status"), children: [_jsx(Ant.Select.Option, { value: "S_00100_CLIENT_REQUEST", children: "S 00100 Client Request" }, "S_00100_CLIENT_REQUEST"), _jsx(Ant.Select.Option, { value: "S_00230_JOB_ESTIMATION_TO_DO", children: "S 00230 Job Estimation To Do" }, "S_00230_JOB_ESTIMATION_TO_DO"), _jsx(Ant.Select.Option, { value: "S_00240_JOB_ESTIMATION_IN_PROGRESS_TECH", children: "S 00240 Job Estimation In Progress Tech" }, "S_00240_JOB_ESTIMATION_IN_PROGRESS_TECH"), _jsx(Ant.Select.Option, { value: "S_00250_JOB_ESTIMATION_DONE_TECH", children: "S 00250 Job Estimation Done Tech" }, "S_00250_JOB_ESTIMATION_DONE_TECH"), _jsx(Ant.Select.Option, { value: "S_00260_JOB_ESTIMATION_TO_CORRECT_TECH", children: "S 00260 Job Estimation To Correct Tech" }, "S_00260_JOB_ESTIMATION_TO_CORRECT_TECH"), _jsx(Ant.Select.Option, { value: "S_00270_JOB_ESTIMATION_VALIDATED", children: "S 00270 Job Estimation Validated" }, "S_00270_JOB_ESTIMATION_VALIDATED"), _jsx(Ant.Select.Option, { value: "S_00340_QUOTATION_CREATED", children: "S 00340 Quotation Created" }, "S_00340_QUOTATION_CREATED"), _jsx(Ant.Select.Option, { value: "S_00350_QUOTATION_SENT", children: "S 00350 Quotation Sent" }, "S_00350_QUOTATION_SENT"), _jsx(Ant.Select.Option, { value: "S_00360_QUOTATION_FOLLOWED_UP", children: "S 00360 Quotation Followed Up" }, "S_00360_QUOTATION_FOLLOWED_UP"), _jsx(Ant.Select.Option, { value: "S_00400_PREPARATION", children: "S 00400 Preparation" }, "S_00400_PREPARATION"), _jsx(Ant.Select.Option, { value: "S_00500_SITE", children: "S 00500 Site" }, "S_00500_SITE"), _jsx(Ant.Select.Option, { value: "S_00620_INVOICE_DRAFT", children: "S 00620 Invoice Draft" }, "S_00620_INVOICE_DRAFT"), _jsx(Ant.Select.Option, { value: "S_00630_INVOICE_CREATED", children: "S 00630 Invoice Created" }, "S_00630_INVOICE_CREATED"), _jsx(Ant.Select.Option, { value: "S_00640_INVOICE_TO_CORRECT", children: "S 00640 Invoice To Correct" }, "S_00640_INVOICE_TO_CORRECT"), _jsx(Ant.Select.Option, { value: "S_00650_INVOICE_SENT", children: "S 00650 Invoice Sent" }, "S_00650_INVOICE_SENT"), _jsx(Ant.Select.Option, { value: "S_00660_INVOICE_FOLLOWED_UP", children: "S 00660 Invoice Followed Up" }, "S_00660_INVOICE_FOLLOWED_UP"), _jsx(Ant.Select.Option, { value: "S_00670_INVOICE_PAID", children: "S 00670 Invoice Paid" }, "S_00670_INVOICE_PAID"), _jsx(Ant.Select.Option, { value: "S_00680_INVOICE_COMPLICATED", children: "S 00680 Invoice Complicated" }, "S_00680_INVOICE_COMPLICATED")] }) })),
            },
            {
                id: "isArchived",
                label: t("management.client_requests.fields.isArchived"),
                name: ["isArchived"],
                initialValue: false,
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsxs(Ant.Radio.Group, { children: [_jsx(Ant.Radio, { value: false, children: "No" }, 0), _jsx(Ant.Radio, { value: true, children: "Yes" }, 1)] }) })),
            },
            {
                id: "archivedAt",
                label: t("management.client_requests.fields.archivedAt"),
                name: ["archivedAt"],
                tooltip: t("management.client_requests.fields.archivedAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsx(UIComponents.DatePicker, { required: false }) })),
            },
            {
                id: "archivingReason",
                label: t("management.client_requests.fields.archivingReason"),
                name: ["archivingReason"],
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsxs(Ant.Select, { allowClear: true, placeholder: t("management.client_requests.fields.archivingReason"), children: [_jsx(Ant.Select.Option, { value: "BILLING_PAID", children: "Billing Paid" }, "BILLING_PAID"), _jsx(Ant.Select.Option, { value: "CANCELED_BY_CLIENT", children: "Canceled By Client" }, "CANCELED_BY_CLIENT"), _jsx(Ant.Select.Option, { value: "TOO_FAR", children: "Too Far" }, "TOO_FAR"), _jsx(Ant.Select.Option, { value: "QUOTATION_REJECTED_OR_TOO_EXPENSIVE", children: "Quotation Rejected Or Too Expensive" }, "QUOTATION_REJECTED_OR_TOO_EXPENSIVE"), _jsx(Ant.Select.Option, { value: "LATE_CLIENT_HANDLING", children: "Late Client Handling" }, "LATE_CLIENT_HANDLING"), _jsx(Ant.Select.Option, { value: "CLIENT_UNREACHABLE", children: "Client Unreachable" }, "CLIENT_UNREACHABLE"), _jsx(Ant.Select.Option, { value: "CREDIT_NOTE", children: "Credit Note" }, "CREDIT_NOTE"), _jsx(Ant.Select.Option, { value: "TO_DELETE", children: "To Delete" }, "TO_DELETE"), _jsx(Ant.Select.Option, { value: "CANNOT_HANDLE", children: "Cannot Handle" }, "CANNOT_HANDLE"), _jsx(Ant.Select.Option, { value: "IRRELEVANT", children: "Irrelevant" }, "IRRELEVANT")] }) })),
            },
            {
                id: "archivingComment",
                label: t("management.client_requests.fields.archivingComment"),
                name: ["archivingComment"],
                tooltip: t("management.client_requests.fields.archivingComment_description"),
                component: Ant.Input,
            },
            {
                id: "archivedById",
                label: t("management.client_requests.fields.archivedBy"),
                name: ["archivedById"],
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", required: false }) })),
            },
        ]);
    }
    static getRequestBody() {
        return {
            _id: 1,
            reference: 1,
            sourceLead: 1,
            sourceLeadPhone: 1,
            nextFollowUp: 1,
            nextFollowUpDate: 1,
            activity: 1,
            description: 1,
            emergencyLevel: 1,
            statusChangeHistory: {
                status: 1,
                updatedAt: 1,
                updatedById: 1,
            },
            status: 1,
            estimatedBy: {
                fullName: 1,
            },
            executedBy: {
                fullName: 1,
            },
            isArchived: 1,
            archivedAt: 1,
            archivingReason: 1,
            archivingComment: 1,
            subjectId: 1,
            archivedBy: {
                _id: 1,
                fullName: 1,
            },
            archivedById: 1,
        };
    }
    onSubmit(_id, values) {
        const { t } = this.i18n;
        return this.collection
            .updateOne(_id, { $set: values })
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.client_requests.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}),
            });
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => ClientRequestsCollection),
    __metadata("design:type", typeof (_a = typeof ClientRequestsCollection !== "undefined" && ClientRequestsCollection) === "function" ? _a : Object)
], ClientRequestEditForm.prototype, "collection", void 0);
ClientRequestEditForm = __decorate([
    Service({ transient: true })
], ClientRequestEditForm);
export { ClientRequestEditForm };
